import { createPinia } from 'pinia'
import { createApp, markRaw } from 'vue'
import App from './App.vue'
import router from './router'
import '@popperjs/core'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'
import './styles/bootstrap_sass.scss'
import './styles/style.scss'
import './styles/theme.scss'
import './styles/desktop.scss'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { getAppPlatform } from '@/utils/appPlatform'
import VueSocialSharing from 'vue-social-sharing'
import VueLazyload from 'vue-lazyload'
import i18n from './i18n'

const app = createApp(App)

const pinia = createPinia()

pinia.use(({ store }) => {
  store.router = markRaw(router)
})

// İlk açılış URL'sindeki platform parametresi yönlendirmelerle kaybolmadan saklansın.
getAppPlatform()

const options = {
  // You can set your default options here
}

const isLocalHost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')

const googleMapsApiKey = (
  (isLocalHost ? process.env.VUE_APP_GOOGLE_MAPS_API_KEY_LOCAL : '') ||
  process.env.VUE_APP_GOOGLE_MAPS_API_KEY ||
  ''
)

// Prevent Google Maps / Vue VDOM timing errors from freezing the scheduler.
// Without this, a single crash in flushJobs halts the entire job queue and
// breaks router navigation (URL changes but page never transitions).
app.config.errorHandler = (err, _instance, info) => {
  console.error('[Vue]', info, err)
}

app.use(router)
  .use(pinia)
  .use(i18n)
  .use(Toast, options)
  .use(VueLazyload)
  .use(VueSocialSharing)
  .use(VueGoogleMaps, {
    load: {
      key: googleMapsApiKey,
      loading: 'async'
    }
  }).mount('#app')
